import { type ReactNode } from 'react';

/**
 * SectionHeader — заголовок секции калькулятора.
 *
 * Прототип 2.12.2 lines 352, 377, 450, 492, 501, 510, 527 (и аналог во всех 2.12.{3..9}):
 *   `<p style={{ fontSize: 26, fontWeight: 700, color: DK, margin: '0 0 14px' }}>...</p>`
 *
 * fontSize 26px — explicit inline style (Tailwind `text-2xl` = 24px, не подходит;
 * design-system token `text-filter-label` = 26px но fontWeight 600 — TZ требует 700).
 * Color наследуется через `text-ink` (DK = #000000 per tailwind.config.ts v0.4.2).
 *
 * Margin-bottom через Tailwind `mb-3.5` (14px per прототип). Можно override через
 * `className="mb-0"` для inline-button layouts (например SectionLighting heading
 * + master toggle в одной flex-row). Tailwind preflight уже обнуляет default h2
 * margin, поэтому inline `margin: 0` не нужен.
 */
export interface SectionHeaderProps {
  children: ReactNode;
  className?: string;
}

export function SectionHeader({ children, className = '' }: SectionHeaderProps) {
  return (
    <h2
      className={`font-bold text-ink mb-3.5 ${className}`.trim()}
      style={{ fontSize: '26px', lineHeight: 1.1 }}
    >
      {children}
    </h2>
  );
}
